<script lang="ts">
    import { onMount } from "svelte";
    import { goto } from "$app/navigation";

    onMount(() => {
        goto("/about");
    });
</script>

<svelte:head>
    <meta http-equiv="refresh" content="0; url=/about" />
</svelte:head>
